export function resolveApiUrl(apiBaseUrl, path) {
    const normalizedApiBaseUrl = apiBaseUrl.replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    if (/^https?:\/\//.test(normalizedApiBaseUrl)) {
        return `${normalizedApiBaseUrl}${normalizedPath}`;
    }
    if (typeof window === 'undefined') {
        return `${normalizedApiBaseUrl}${normalizedPath}`;
    }
    return new URL(`${normalizedApiBaseUrl}${normalizedPath}`, window.location.origin).toString();
}
export function resolvePublicApiUrl(apiBaseUrl, path) {
    if (/^https?:\/\//u.test(path)) {
        return path;
    }
    const normalizedApiBaseUrl = apiBaseUrl.replace(/\/+$/, '');
    const publicApiBaseUrl = normalizedApiBaseUrl.replace(/\/v1$/u, '');
    return resolveApiUrl(publicApiBaseUrl, path);
}
//# sourceMappingURL=api-url.js.map